class ManageServerControllersController {
    constructor($window, $uibModal, ModalService, toastr, ngProgressFactory, ServerControllersServiceApi, $location) {
        this.$onInit = () => {
            this.state = {
                activeOnly: false
            };
            this.rowCount = 0;
            this.data = {
                serverControllers: [],
                filterOptions: {
                    allControllers: [],
                    activeOnly: []
                }
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            let columnDefs = [
                { headerName: 'Id', field: 'Id', minWidth: 60, width: 60, maxWidth: 60, suppressMovable: true, suppressMenu: true, resizable: false, sort: 'asc' },
                { headerName: 'Name', field: 'Name', width: 135, minWidth: 135 },
                { headerName: 'Address', field: 'Address', width: 150, minWidth: 130 },
                { headerName: 'API Service Port', field: 'APIServicePort', width: 110, minWidth: 100 },
                { headerName: 'Admin Service Port', field: 'AdminServicePort', width: 110, minWidth: 100 },
                { headerName: 'Repository', field: 'RepositoryEnabled', width: 80, minWidth: 60, cellRenderer: this.repoStatusRenderer, sortable: true, suppressMenu: true, resizable: true, suppressMovable: true },
                { headerName: 'Active', field: 'IsDeleted', width: 60, minWidth: 60, cellRenderer: this.statusRenderer, sortable: true, suppressMenu: true, resizable: true, suppressMovable: true },
                { headerName: 'Actions', width: 150, maxWidth: 150, minWidth: 150, cellRenderer: this.actionsCellRenderer, sortable: false, suppressMenu: true, resizable: false, suppressMovable: true }
            ];
            this.gridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: false
                },
                columnDefs: columnDefs,
                onModelUpdated: this.onModelUpdated,
                rowHeight: 30,
                rowSelection: 'single',
                angularCompileRows: true,
                suppressMovableColumns: true // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
            };
            this.getServerControllers();
        };
        this.actionsCellRenderer = (row) => {
            let editServerController = this.createAction('vm.editServerController(data)', 'Edit ' + row.data.Name, 'glyphicon glyphicon-pencil', '');
            let viewSimulators = this.createAction('vm.viewSimulators(data)', 'View Simulators Using ' + row.data.Name, 'glyphicon glyphicon-search', '');
            let viewLogs = this.createAction('vm.viewLogs(data)', 'View Server Logs for ' + row.data.Name, 'glyphicon glyphicon-folder-open', '');
            let deactivateServerController = '';
            if (!row.data.IsDeleted) {
                deactivateServerController = this.createAction('vm.deactivateServerController(data)', 'Deactivate ' + row.data.Name, 'glyphicon glyphicon-trash', '');
            }
            return '<div class="ag-grid-actions-container">' + editServerController + viewSimulators + viewLogs + deactivateServerController + '</div>';
        };
        this.statusRenderer = (row) => {
            let active = row.data.IsDeleted ? 'No' : 'Yes';
            return ['<div>' + active + '</div>'].join(' ');
        };
        this.repoStatusRenderer = (row) => {
            let active = row.data.RepositoryEnabled ? 'Yes' : 'No';
            return ['<div>' + active + '</div>'].join(' ');
        };
        this.createAction = (method, popoverText, icon, spinner) => {
            let action = [
                '<button class="btn btn-xs btn-info"',
                'ng-click="', method, '"',
                'uib-popover="', popoverText, '"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="', icon, '">',
                '</i>',
                spinner,
                '</button>'
            ].join(' ');
            return action;
        };
        this.addServerController = () => {
            this.editServerController(null);
        };
        this.editServerController = (serverController) => {
            let serverControllerEditModal = this.uibModal.open({
                animation: true,
                component: 'addEditServerControllerModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    serverController: () => {
                        return serverController;
                    }
                }
            });
            serverControllerEditModal.result.then((value) => {
                this.getServerControllers();
                this.toastr.info([
                    'Server Controller ',
                    value
                ].join(''));
            });
        };
        this.deactivateServerController = (serverController) => {
            this.startLoading();
            this.ServerControllersServiceApi.getSimulatorsUsingServerControllerWithId(serverController.Id).then((response) => {
                this.endLoading();
                let sims = response.data;
                let modalOptions = {
                    backdrop: 'static',
                    actionButtonText: 'Deactivate',
                    closeButtonText: 'Cancel',
                    headerText: 'Deactivate Server Controller',
                    bodyText: 'Are you sure you want to deactivate ' + serverController.Name + '?'
                };
                if (sims.length > 0) {
                    modalOptions.bodyText = response.data.length + ' simulators still use this controller. ' + modalOptions.bodyText;
                }
                this.ModalService.showModal({}, modalOptions).then(() => {
                    this.startLoading();
                    serverController.IsDeleted = true;
                    this.ServerControllersServiceApi.save(serverController).then((response) => {
                        this.endLoading();
                        if (response.status === 200) {
                            this.getServerControllers();
                        }
                        else {
                            this.toastr.error('Failed to delete ' + serverController.Name, 'Error');
                        }
                    });
                });
            });
        };
        this.viewSimulators = (serverController) => {
            this.startLoading();
            this.ServerControllersServiceApi.getSimulatorsUsingServerControllerWithId(serverController.Id).then((response) => {
                this.endLoading();
                let sims = response.data;
                let viewModal = this.uibModal.open({
                    animation: true,
                    component: 'viewSmallSimulatorListModal',
                    size: 'md',
                    backdrop: 'static',
                    resolve: {
                        title: () => {
                            return 'Simulators using ' + serverController.Name;
                        },
                        simulators: () => {
                            return sims;
                        }
                    }
                });
                viewModal.result.then(() => {
                });
            });
        };
        this.viewLogs = (serverController) => {
            this.$location.path('/ServerExplorer');
        };
        this.getServerControllers = () => {
            this.startLoading();
            this.ServerControllersServiceApi.getAll().then((response) => {
                this.endLoading();
                this.data.serverControllers = response.data;
                this.gridOptions.api.setRowData(this.data.serverControllers);
                this.gridOptions.api.sizeColumnsToFit();
                let OnlyActiveControllers = _.filter(this.data.serverControllers, Control => {
                    return Control.IsDeleted === false;
                });
                this.data.filterOptions = {
                    allControllers: this.data.serverControllers,
                    activeOnly: OnlyActiveControllers
                };
                this.filterRows();
                this.gridOptions.api.setRowData(this.data.serverControllers);
            });
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
        };
        this.startLoading = () => {
            this.traceProgress.start();
            if (!_.isNil(this.gridOptions.api)) {
                this.gridOptions.api.showLoadingOverlay();
            }
        };
        this.endLoading = () => {
            this.traceProgress.complete();
            if (!_.isNil(this.gridOptions.api)) {
                this.gridOptions.api.hideOverlay();
            }
        };
        this.toggleActiveOnly = () => {
            this.state.activeOnly = !this.state.activeOnly;
            this.filterRows();
            this.gridOptions.api.setRowData(this.data.serverControllers);
        };
        this.filterRows = () => {
            if (this.state.activeOnly) {
                this.data.serverControllers = this.data.filterOptions.activeOnly;
            }
            else {
                this.data.serverControllers = this.data.filterOptions.allControllers;
            }
        };
        this.window = $window;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.ngProgressFactory = ngProgressFactory;
        this.ServerControllersServiceApi = ServerControllersServiceApi;
        this.$location = $location;
    }
}
angular.module('app').component('manageServerControllers', {
    bindings: {},
    templateUrl: 'Scripts/App/partials/ServerControllers/manage-server-controllers.tpl.html',
    controllerAs: 'vm',
    controller: ManageServerControllersController
});
